// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"f2ec1689","453":"0cf863ae"}[chunkId] + ".chunk.js";
};